import React, { Component } from 'react';
import { Modal, Button } from "react-bootstrap"
import { withTranslation } from 'react-i18next';

class DeleteLocationConfirm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            transPage: "modals.location_delete."
        }

        this.deleteSelectedLocation = this.deleteSelectedlocation.bind(this)
        this.onOpenModal = this.onOpenModal.bind(this)
        // this.onHideModal = this.onHideModal.bind(this)
    }

    deleteSelectedlocation() {
        // dari props method nya
        this.props.deleteSelectedLocation() 
    }

    onOpenModal() {
        //console.log("modal open")
    }

    
    render() {
        const {t} = this.props;
        const listLocations = this.props.selectedLocations.map(item => {
            return (<li key={item.id}>{ item.location_type } - {item.address}</li>)
        })

        return (
            <Modal show={this.props.show} onHide={() => this.props.onHide()} onShow={() => this.onOpenModal()}>
                {this.props.loadingModal}
                <Modal.Header closeButton className="bg-danger">
                    <Modal.Title>{t(this.state.transPage + "title")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{t(this.state.transPage + "confirmation_text")}</p>
                    <ul>
                        {listLocations}
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.props.onHide()}>
                        {t('cancel')}
                    </Button>
                    <Button variant="danger" onClick={() => this.deleteSelectedLocation()}>
                        <i className="fa fa-trash">&nbsp;</i>
                        {t(this.state.transPage + "delete_location")}
                    </Button>   
                </Modal.Footer>
            </Modal>
        );
    }
}

export default withTranslation()(DeleteLocationConfirm);